import React from 'react';

import {
  ProgramWeeks,
  ProgramHeader,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import Workout from './Workout';

type Props = {
  readOnly: boolean,
  programId: number,
  resourceType: string,
};

const ProgramWorkouts = ({
  readOnly,
  programId,
  resourceType,
}: Props) => (
  <Flex width="100%" height="calc(100% - 50px)" column>
    <ProgramHeader
      readOnly={readOnly}
      programId={programId}
      resourceType={resourceType}
    />
    <Flex
      width="100%"
      height="calc(100% - 70px)"
      scrollY
    >
      <ProgramWeeks
        readOnly={readOnly}
        programId={programId}
        resourceType={resourceType}
      />
      <Workout
        readOnly={readOnly}
        resourceType={resourceType}
        programId={programId}
      />
    </Flex>
  </Flex>
);

export default ProgramWorkouts;
